/*=========================================================================================
  File Name: moduleMap.js
  Description: Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleMapState.js";
import mutations from "./moduleMapMutations.js";
import actions from "./moduleMapActions.js";
import getters from "./moduleMapGetters.js";

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
